import { Navigate } from 'react-router-dom';
import preloadChunks from '@/routes/preloadChunks.util';
import Welcome from '@/pages/Sign/Welcome';
import Success from '@/pages/Sign/Success';
import Fail from '@/pages/Sign/Fail';
import Cancel from '@/pages/Sign/Cancel';
import WebidForm from '@/pages/Sign/WebidForm';
import WebidReturn from '@/pages/Sign/WebidReturn';

const signRoutes = [
  {
    path: ':workflowId/:signerId',
    children: [
      { index: true, element: <Navigate to="welcome" replace /> },
      {
        path: 'welcome',
        element: <Welcome />,
      },
      {
        path: 'document',
        lazy: async () => ({
          Component: (await preloadChunks['sign.document']()).default,
        }),
      },
      { path: 'webid-form', element: <WebidForm /> },
      { path: 'webid-return', element: <WebidReturn /> },
      { path: 'return-url', element: <Success /> },
      { path: 'cancel', element: <Cancel /> },
      { path: 'fail', element: <Fail /> },
    ],
  },
];

export default signRoutes;
